import React from 'react';
import { useTranslation } from 'react-i18next';
import ChoiceAnswer from '../../Answer/ChoiceAnswer';

import styles from './styles.module.scss';

const ChoiceQuestion = ({ number, stage, question, activeQuestion, setSelectedAnswer, disabled }) => {
  const { t } = useTranslation();

  return <div className={styles.question + ' ' + (question.answer ? styles.complete : disabled ? styles.disabled : '') + ' ' + (number === activeQuestion ? styles.active : '')}>
    <h3 className={styles.title}>
      {t(`tool_ui.${stage.key}.${question.key}`)}
    </h3>
    <div className={styles.answers}>
      {question.choices.map((answer, index) => <ChoiceAnswer
        key={index}
        question={question}
        item={answer}
        setSelectedAnswer={setSelectedAnswer}
        disabled={disabled}
      />)}
    </div>
  </div>;
}

export default ChoiceQuestion;
